import React, {Component} from 'react';
import { Nav} from 'react-bootstrap';
import MenuPerfil from './menu_perfil';


class topo_professor extends Component {
    render() {

    const heigth = {    'height': '40px'}
        return (
            <div>
                <nav className="navbar navbar-inverse navbar-fixed-top" style={heigth}>
                    <div className="container-fluid">
                        <div className="navbar-header">
                            <button
                                type="button"
                                className="navbar-toggle collapsed"
                                data-toggle="collapse"
                                data-target="#navbar"
                                aria-expanded="false"
                                aria-controls="navbar">
                            </button>
                            <a id="menu-toggle" className="navbar-brand" href={void(0)}>
                                <span className="glyphicon glyphicon-align-justify"></span>
                            </a>                           
                        </div>
                        <div id="navbar" className="navbar-collapse collapse hidden-xs">
                            <Nav className="navbar-right nav navbar-nav">
                                <MenuPerfil/>
                            </Nav>
                        </div>
                    </div>
                </nav>

            </div>
        );
    }
}

export default topo_professor;


// WEBPACK FOOTER //
// ./src/components/professor/topo/topo_professor.js